import styled from 'styled-components';
import LS from '../styles/layoutStyled';
import CS from '../styles/componentStyled';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useMemo, useEffect } from 'react';
import { Icon } from './Icon';

const BottomMenuBox = () => {
  const location = useLocation();
  const isActive = (pathname: string) => {
    return location.pathname === pathname ? 'active' : '';
  };

  return (
    <>
      <MenuBox>
        <Link to="/worknummanage" className={isActive('/worknummanage')}>
          <span className="img-box">
            <Icon
              name="EdtiIcon"
              size="26px"
              color={isActive('/worknummanage') ? '#191F28' : '#67717E'}
            />
          </span>
          <h3>일보 관리</h3>
        </Link>
        <Link to="/dispatchlist" className={isActive('/dispatchlist')}>
          <span className="img-box">
            <Icon
              name="ListIcon"
              size="26px"
              color={isActive('/dispatchlist') ? '#191F28' : '#67717E'}
            />
          </span>
          <h3>전체 목록</h3>
        </Link>
        <Link to="/myroomlist" className={isActive('/myroomlist')}>
          <span className="img-box">
            <Icon
              name="MyListIcon"
              size="26px"
              color={isActive('/myroomlist') ? '#191F28' : '#67717E'}
            />
          </span>
          <h3>내 방 목록</h3>
        </Link>
        <Link to="/myinfor" className={isActive('/myinfor')}>
          <span className="img-box">
            <Icon
              name="PeopleIcon"
              size="26px"
              color={isActive('/myinfor') ? '#191F28' : '#67717E'}
            />
          </span>
          <h3>내 정보</h3>
        </Link>
      </MenuBox>
    </>
  );
};

export default BottomMenuBox;

const MenuBox = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  gap: 16px;
  box-sizing: border-box;
  padding-top: 16px;
  background-color: #fff;
  > a {
    width: 60px;
    height: 60px;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    .img-box {
      margin: 0 auto;
    }
    h3 {
      width: 100%;
      text-align: center;
      font-size: 11px;
      color: #67717e;
      font-weight: 500;
      margin-top: 8px;
    }
  }
  > a.active {
    h3 {
      color: #191f28;
      font-weight: 700;
    }
  }
`;
